module.exports = __webpack_public_path__ + "static/media/menu-theme.931633ce.mp3";